import "../styles/physio.css";
import TableOfContents from "../components/physios/TableOfContents";
import PhysioHero from "../components/physios/PhysioHero";
import PhysioPositioning from "../components/physios/PhysioPositioning";
import ExerciseDatabase from "../components/physios/ExerciseDatabase";
import TreatmentPlans from "../components/physios/TreatmentPlans";
import PatientExperience from "../components/physios/PatientExperience";
import ContributeDatabase from "../components/physios/ContributeDatabase";
import WhyRevimo from "../components/physios/WhyRevimo";
import PhysioCTA from "../components/physios/PhysioCTA";
import Header from "../components/physios/HeaderPhysio";
import Footer from "../components/Footer";
import { useCurrentLang } from "../hooks/useCurrentLang";

// Table of contents — edit labels here, make sure id matches the section's id prop
const TOC_SECTIONS = [
  { id: "hero",        label: "Introduction" },
  { id: "positioning", label: "Our Philosophy" },
  { id: "database",    label: "Exercise Database" },
  { id: "plans",       label: "Treatment Plans" },
  { id: "patient",     label: "Patient Experience" },
  { id: "contribute",  label: "Contribute" },
  { id: "why",         label: "Why Revimo" },
  { id: "cta",         label: "Get Started" },
];

export default function PhysioPage() {
  const currentLang = useCurrentLang()

  return (
    <div className="page--physio">
      <Header lang={currentLang}/>

      <div className="physio-layout">
        {/* Sticky Table of Contents — left sidebar, hidden on mobile */}
        <TableOfContents sections={TOC_SECTIONS} />

        {/* Main centered content column */}
        <main className="physio-main">
          <PhysioHero />
          <PhysioPositioning />
          <ExerciseDatabase />
          <TreatmentPlans />
          <PatientExperience />
          <ContributeDatabase />
          <WhyRevimo />
          <PhysioCTA />
        </main>
      </div>

      <Footer lang={currentLang}/>
    </div>
  );
}
